export class RegexPatterns {
  static readonly EmailAddress = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/i;

  // for telephone allow numbers with or without dashes and allow for country code
  static readonly Telephone = /^(\+?\d{1,3}[- ]?)?\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/;

  // eslint-disable-next-line max-len
  static readonly CommaSeparatedEmailAddresses =
    /^([a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,})(\s*,\s*[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,})*$/i;
}
